module.exports = __webpack_public_path__ + "static/media/apple.32b3b567.png";